import React from "react";
import { Link } from "react-scroll";
import { useLocation } from "react-router-dom";
import { useTheme } from "../../context/ThemeContext";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import { styled } from "@mui/material/styles";
import "./header.css";

import SwitchIconLight from "../../assets/switch-icon.svg";
import SwitchIconDark from "../../assets/switch-icon-dark.svg";

const Header = () => {
  const { theme, toggleTheme, isDark } = useTheme();
  const location = useLocation();
  const isHomePage = location.pathname === "/";

  const IOSSwitch = styled((props) => (
    <Switch
      focusVisibleClassName=".Mui-focusVisible"
      disableRipple
      {...props}
    />
  ))(({ theme: muiTheme }) => ({
    position: "relative",
    width: 42,
    height: 26,
    padding: 0,
    "& .MuiSwitch-switchBase": {
      padding: 0,
      margin: 2,
      transitionDuration: "300ms",
      "&.Mui-checked": {
        transform: "translateX(16px)",
        color: "#fff",
        "& + .MuiSwitch-track": {
          backgroundColor: isDark ? "transparent" : "#C3C3C3",
          opacity: 1,
          border: 0,
        },
        "&.Mui-disabled + .MuiSwitch-track": {
          opacity: 0.5,
        },
      },
      "&.Mui-focusVisible .MuiSwitch-thumb": {
        color: "#33cf4d",
        border: "6px solid #fff",
      },
      "&.Mui-disabled .MuiSwitch-thumb": {
        color: isDark ? muiTheme.palette.grey[600] : muiTheme.palette.grey[100],
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: isDark ? 0.3 : 0.7,
      },
    },
    "& .MuiSwitch-thumb": {
      position: "relative",
      boxSizing: "border-box",
      width: 22,
      height: 22,
      transition: muiTheme.transitions.create(["transform", "opacity"], {
        duration: 300,
      }),
    },
    "& .MuiSwitch-thumb:before": {
      content: '""',
      position: "absolute",
      top: "50%",
      left: "50%",
      width: 20,
      height: 20,
      backgroundImage: `url(${
        theme === "light" ? SwitchIconLight : SwitchIconDark
      })`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      backgroundSize: "contain",
      transform: "translate(-50%, -50%)",
      transition: "background-image 0.3s ease",
    },
    "& .MuiSwitch-track": {
      borderRadius: 26 / 2,
      backgroundColor: isDark ? "#C3C3C3" : "#666666",
      opacity: 1,
      transition: muiTheme.transitions.create(["background-color"], {
        duration: 300,
      }),
    },
  }));

  return (
    <header className="container pt-3">
      <nav className="navbar navbar-expand-lg">
        <div className="container-fluid">
          <a className="navbar-brand" href="/">
            Mirza Kurbegović
          </a>

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div
            className="collapse navbar-collapse gap-5 align-items-center"
            id="navbarNav"
          >
            {isHomePage ? (
              <ul className="navbar-nav gap-4 ms-auto mb-2 mb-lg-0">
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="about"
                    containerId="scrollableContainer"
                    smooth={true}
                    duration={500}
                    activeClass="active"
                    spy={true}
                    offset={-70}
                  >
                    About
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="works"
                    containerId="scrollableContainer"
                    smooth={true}
                    duration={500}
                    activeClass="active"
                    spy={true}
                    offset={-70}
                  >
                    Work
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="contact"
                    containerId="scrollableContainer"
                    smooth={true}
                    duration={500}
                    activeClass="active"
                    spy={true}
                    offset={-70}
                  >
                    Contact
                  </Link>
                </li>
              </ul>
            ) : (
              <ul className="navbar-nav gap-4 ms-auto mb-2 mb-lg-0">
                <li className="nav-item">
                  <a className="nav-link" href="/">
                    Home
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="/#about">
                    About
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="/#works">
                    Work
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="/#contact">
                    Contact
                  </a>
                </li>
              </ul>
            )}

            <div className="theme-switch-container">
              <FormControlLabel
                control={
                  <IOSSwitch
                    checked={theme === "light"}
                    onChange={toggleTheme}
                    inputProps={{ "aria-label": "Theme toggle" }}
                  />
                }
                label=""
              />
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
